import React from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import './PageBanner.css';
import { initBannerSwiper } from '../../../utils/swiperBannerInit';

function BannerSlide({ banner, heading, subheading }) {
  if (!banner) return null;

  const mainHeading = heading ?? banner.main_heading_text;
  const subHeading = subheading ?? banner.sub_heading_text;

  return (
    <div className="page-banner-item">
      <picture>
        {banner.imageMobileUrl && (
          <source media="(max-width: 768px)" srcSet={banner.imageMobileUrl} />
        )}
        <img
          src={banner.imageDesktopUrl}
          alt={banner.name || ''}
          className="page-banner-img"
        />
      </picture>
      {(mainHeading || subHeading || banner.button_text) && (
        <div className="page-banner-overlay">
          <div className="page-banner-content">
            {mainHeading && (
              <h2
                className="page-banner-heading"
                style={{ color: banner.main_heading_text_color || '#ffffff' }}
              >
                {mainHeading}
              </h2>
            )}
            {subHeading && (
              <p
                className="page-banner-subheading"
                style={{ color: banner.sub_heading_text_color || '#ffffff' }}
              >
                {subHeading}
              </p>
            )}
            {banner.button_text && banner.button_action_url && (
              <div className="page-banner-actions">
                <Link
                  to={banner.button_action_url}
                  className="page-banner-btn"
                  style={{
                    backgroundColor: banner.button_background_color || '#0066cc',
                    color: banner.button_text_color || '#ffffff',
                  }}
                >
                  {banner.button_text}
                </Link>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

/**
 * @param {object} [props.banner] - single banner (legacy)
 * @param {object[]} [props.banners] - full list from CMS; enables carousel + arrows when length > 1
 */
const PageBanner = ({ banner: singleBanner, banners: bannersProp, heading, subheading }) => {
  const banners = bannersProp?.length
    ? bannersProp
    : singleBanner
      ? [singleBanner]
      : [];

  if (banners.length === 0) return null;

  if (banners.length === 1) {
    return (
      <div className="page-banner-wrapper">
        <div className="page-banner-inner">
          <BannerSlide banner={banners[0]} heading={heading} subheading={subheading} />
        </div>
      </div>
    );
  }

  const swiperKey = banners.map((b) => b.id ?? '').join('-');

  return (
    <div className="page-banner-wrapper page-banner-wrapper--swiper">
      <Swiper
        key={swiperKey}
        initialSlide={0}
        modules={[Navigation, Autoplay]}
        navigation
        loop={banners.length > 2}
        spaceBetween={0}
        slidesPerView={1}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        className="page-banner-swiper"
        onSwiper={initBannerSwiper}
      >
        {banners.map((b, idx) => (
          <SwiperSlide key={b.id ?? `banner-${idx}`}>
            <BannerSlide banner={b} heading={heading} subheading={subheading} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default PageBanner;
